import React from "react";
import { MessageSquare, Paperclip, Repeat, ListChecks } from "lucide-react";
import { formatDueLabel, isOverdueDueLabel } from "../utils/taskDates";
import { isRecurringTask } from "../utils/taskReminderSync";
import {
    assigneeInitials,
    taskAttachmentCount,
    taskCommentCount,
    taskProjectName,
} from "../utils/taskCardMeta";
import { checklistProgress } from "../utils/taskChecklist";

export function TaskCardMeta({ task, person, isStaff, includeTitle = true }) {
    const dueLabel = formatDueLabel(task);
    const priority = String(task.priority || "medium").toLowerCase();
    const listName = taskProjectName(task);
    const comments = taskCommentCount(task);
    const attachments = taskAttachmentCount(task);
    const initials = person ? assigneeInitials(person) : null;
    const progress = checklistProgress(task);

    return (
        <>
            {includeTitle && (
                <p className="task-board__name">{task.title || "Untitled task"}</p>
            )}
            <p
                className={`task-board__due ${
                    isOverdueDueLabel(dueLabel) ? "task-board__due--overdue" : ""
                } ${dueLabel === "Due Today" ? "task-board__due--today" : ""}`}
            >
                {dueLabel || "No due date"}
            </p>
            <div className="task-board__meta-row">
                <span className={`task-board__priority task-board__priority--${priority}`}>
                    {task.priority || "medium"}
                </span>
                {isRecurringTask(task) && (
                    <span className="task-board__recurring" title="Repeating task">
                        <Repeat size={11} />
                    </span>
                )}
                {isStaff && task.assigned_by === "Admin" && (
                    <span className="task-board__from-admin">From admin</span>
                )}
            </div>
            <div className="task-board__foot">
                <div className="task-board__foot-start">
                    {listName && <span className="task-board__list">{listName}</span>}
                    {progress.total > 0 && (
                        <span className="task-board__count-chip" title="Checklist">
                            <ListChecks size={11} />
                            {progress.done}/{progress.total}
                        </span>
                    )}
                    {comments > 0 && (
                        <span className="task-board__count-chip" title={`${comments} comments`}>
                            <MessageSquare size={11} />
                            {comments}
                        </span>
                    )}
                    {attachments > 0 && (
                        <span className="task-board__count-chip" title={`${attachments} attachments`}>
                            <Paperclip size={11} />
                            {attachments}
                        </span>
                    )}
                </div>
                {person && (
                    <span className="task-board__avatar" title={person} aria-label={person}>
                        {initials}
                    </span>
                )}
            </div>
        </>
    );
}
